import { useCallback, useRef, useState } from 'react';

export function useTextVersionStack() {
  const stacksRef = useRef({});
  const [undoCounts, setUndoCounts] = useState({});

  const syncCount = useCallback((key) => {
    setUndoCounts((current) => ({
      ...current,
      [key]: stacksRef.current[key]?.length || 0,
    }));
  }, []);

  const push = useCallback(
    (key, text) => {
      if (!stacksRef.current[key]) {
        stacksRef.current[key] = [];
      }
      stacksRef.current[key].push(text);
      syncCount(key);
    },
    [syncCount]
  );

  const undo = useCallback(
    (key) => {
      const stack = stacksRef.current[key];
      if (!stack?.length) {
        return null;
      }
      const text = stack.pop();
      syncCount(key);
      return text;
    },
    [syncCount]
  );

  const canUndo = useCallback((key) => (undoCounts[key] || 0) > 0, [undoCounts]);

  const clear = useCallback(
    (key) => {
      delete stacksRef.current[key];
      syncCount(key);
    },
    [syncCount]
  );

  return { push, undo, canUndo, clear };
}
